'use strict';exports.__esModule = true;exports.swiperParams = undefined;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactIdSwiper = require('react-id-swiper');var _reactIdSwiper2 = _interopRequireDefault(_reactIdSwiper);

var _PartnerLogo = require('./PartnerLogo');var _PartnerLogo2 = _interopRequireDefault(_PartnerLogo);

var _RealtorPartners = require('./RealtorPartners.scss');var styles = _interopRequireWildcard(_RealtorPartners);
var _logos = require('./logos');var _logos2 = _interopRequireDefault(_logos);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} // styles

var swiperParams = exports.swiperParams = {
  rebuildOnUpdate: true,
  slidesPerView: 2.5,
  threshold: 20,
  // slidesPerColumnFill: 'row',
  slidesOffsetBefore: 16,
  slidesOffsetAfter: 16,
  slidesPerGroup: 1,
  // slidesPerColumn: 2,
  spaceBetween: 0,
  pagination: {
    el: '.swiper-pagination' },

  navigation: {
    nextEl: null,
    prevEl: null } };



var RealtorPartners = function RealtorPartners(props) {
  var renderPartnerLogo = function renderPartnerLogo(link) {return _react2.default.createElement(_PartnerLogo2.default, { link: link, key: link });};

  var renderMobilePartnerLogo = function renderMobilePartnerLogo(logoGroup, idx) {return (
      _react2.default.createElement('div', { className: styles.logoWrapper, key: idx },
        logoGroup));};



  var renderLogos = function renderLogos() {return _logos2.default.map(renderPartnerLogo);};

  var reduceMobileLogos = function reduceMobileLogos() {return _logos2.default.reduce(function (acc, link, idx, array) {
      var subArray = acc[acc.length - 1];
      var logo = renderPartnerLogo(link);

      subArray.push(logo);

      if (subArray.length === 2 && idx !== array.length - 1) {
        acc.push([]);
      }

      return acc;
    }, [[]]);};

  var renderMobileContent = function renderMobileContent() {return (
      _react2.default.createElement(_reactIdSwiper2.default, swiperParams,
        reduceMobileLogos().map(renderMobilePartnerLogo)));};



  return (
    _react2.default.createElement('div', { className: styles.partnersWrapper },
      props.isMobile ? renderMobileContent() : renderLogos()));


};

RealtorPartners.propTypes = {
  isMobile: _propTypes2.default.bool };exports.default =


RealtorPartners;


//////////////////
// WEBPACK FOOTER
// ./src/components/RealtorPartners/RealtorPartners.js
// module id = 2861
// module chunks = 0